<script>
  import { crossfade, fade } from "svelte/transition";
  import { flip } from "svelte/animate";
  let messages = [];
  const TIME = 5000;

  const _info = console.info;
  console.info = function(msg, ...params) {
    const snack = msg && msg.snack
    if (snack) {
      snack.show = true;
      snack.timestamp = Date.now();
      snack.type = snack.type || "default";
      
      if (snack.time !== 0)
        setTimeout(() => {
          snack.show = false;
        }, time || TIME);

      messages = [...messages, snack];      
      messages = messages;
      _info(snack.msg);
    } else _info(msg, ...params);
    console.log("messages", messages);
  };

  function nofn (){}
</script>

<style>
  .default {
    @apply bg-white;
  }
  .success {
    @apply bg-green-600 text-white;
  }
  .error {
    @apply bg-red-600 text-white;
  }
</style>

<div class="absolute bottom-0 mr-8 mb-8 right-0">
  <ul>
    {#each messages.filter(msg => msg.show) as message (message.timestamp)}
      <li on:click={message.fn || nofn}
        class={message.type + ' ' + (message.fn? 'cursor-pointer' : '') + ' bg-white px-4 py-2 mb-4 shadow'}
        transition:fade
        animate:flip>
        {message.msg}
      </li>
    {/each}
  </ul>
</div>
